/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
  Typography,
  Button,
  Menu,
  MenuItem,
  Checkbox,
  Chip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import AutorenewOutlinedIcon from "@mui/icons-material/AutorenewOutlined";
import InfoIcon from "@mui/icons-material/Info";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

const ServiceBookings = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedOrder, setSelectedOrder] = useState<any>(null);
  const [selectedBookings, setSelectedBookings] = useState<string[]>([]);

  const handleActionClick = (
    event: React.MouseEvent<HTMLElement>,
    order: any,
  ) => {
    setAnchorEl(event.currentTarget);
    setSelectedOrder(order);
  };

  const handleCloseActions = () => {
    setAnchorEl(null);
    setSelectedOrder(null);
  };

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = orderData.map((n) => n.bookingId);
      setSelectedBookings(newSelected);
      return;
    }
    setSelectedBookings([]);
  };

  const handleSelectOne = (id: string) => {
    const selectedIndex = selectedBookings.indexOf(id);
    let newSelected: string[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedBookings, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedBookings.slice(1));
    } else if (selectedIndex === selectedBookings.length - 1) {
      newSelected = newSelected.concat(selectedBookings.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedBookings.slice(0, selectedIndex),
        selectedBookings.slice(selectedIndex + 1),
      );
    }

    setSelectedBookings(newSelected);
  };

  const orderData = [
    {
      bookingId: "BK-2025-001",
      serviceProvider: {
        name: "QuickFix Services",
        email: "support@quickfix.com",
      },
      vendor: {
        name: "TechHub Electronics",
        email: "sales@techhub.com",
      },
      bookingDate: "12/12/2025",
      bookingTime: "10:30 AM",
      amount: "AED 450.00",
      payment: "Paid",
      status: "Pending",
    },
    {
      bookingId: "BK-2025-002",
      serviceProvider: {
        name: "UrbanCare Solutions",
        email: "contact@urbancare.com",
      },
      vendor: {
        name: "Fashion Hub",
        email: "support@fashionhub.com",
      },
      bookingDate: "13/12/2025",
      bookingTime: "02:15 PM",
      amount: "AED 320.00",
      payment: "Paid",
      status: "Ongoing",
    },
    {
      bookingId: "BK-2025-003",
      serviceProvider: {
        name: "HomePro Services",
        email: "info@homepro.com",
      },
      vendor: {
        name: "Handmade Store",
        email: "hello@handmade.com",
      },
      bookingDate: "14/12/2025",
      bookingTime: "11:00 AM",
      amount: "AED 180.00",
      payment: "Cash",
      status: "Completed",
    },
    {
      bookingId: "BK-2025-004",
      serviceProvider: {
        name: "Elite Repairs",
        email: "support@eliterepairs.com",
      },
      vendor: {
        name: "Premium Seller",
        email: "premium@seller.com",
      },
      bookingDate: "15/12/2025",
      bookingTime: "04:45 PM",
      amount: "AED 600.00",
      payment: "Refunded",
      status: "Cancelled",
    },
  ];

  return (
    <>
      <div className="main_title">
        <h1>Service Booking Management</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Service Booking Management
        </p>
      </div>
      <div className="stats_boxes gap_m">
        <div className="cards">
          <div className="data_top">
            <h2>
              120 <p>Total Bookings</p>
            </h2>
            <figure className="blue">
              <Inventory2OutlinedIcon fontSize="large" />
            </figure>
          </div>
          <div className="ai_insight positive">
            <span>12.5% increase</span>
          </div>
        </div>
        <div className="cards">
          <div className="data_top">
            <h2>
              AED 250,000 <p>Total Revenue</p>
            </h2>
            <figure className="green">
              <AttachMoneyOutlinedIcon fontSize="large" />
            </figure>
          </div>
          <div className="ai_insight positive">
            <span>8.3% growth this month</span>
          </div>
        </div>
        <div className="cards">
          <div className="data_top">
            <h2>
              14 <p>Pending</p>
            </h2>
            <figure className="warning">
              <HourglassEmptyOutlinedIcon fontSize="large" />
            </figure>
          </div>
          <div className="ai_insight negative">
            <span>7% higher than last week</span>
          </div>
        </div>
        <div className="cards">
          <div className="data_top">
            <h2>
              32 <p>Ongoing</p>
            </h2>
            <figure className="blue">
              <AutorenewOutlinedIcon fontSize="large" />
            </figure>
          </div>
          <div className="ai_insight neutral">
            <span>Stable Ongoing rate</span>
          </div>
        </div>
      </div>

      {/* AI Insights & Recommendations Alert Box */}
      <div className="cards ai_insight_card mt_20">
        <div className="ai_card_header">
          <div className="left">
            <Stack direction="row" spacing={1} alignItems="center">
              <img
                src="/static/images/ai_icon.svg"
                alt="AI"
                style={{ width: 20 }}
              />
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                AI Insights & Recommendations
              </Typography>
            </Stack>
          </div>
          <div className="right">
            <Button size="small" endIcon={<span>▾</span>}>
              Advise Actions
            </Button>
          </div>
        </div>
        <Stack spacing={2} sx={{ mt: 2 }}>
          <Box
            className="ai_alert warning"
            sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}
          >
            <InfoIcon sx={{ fontSize: 20, color: "#ed6c02", mt: 0.5 }} />
            <Box flex={1}>
              <Typography variant="body2">
                <b>BK-2025-004</b> flagged as high risk due to frequent
                cancellations by Premium Seller
              </Typography>
            </Box>
          </Box>
          <Box
            className="ai_alert info"
            sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}
          >
            <InfoIcon sx={{ fontSize: 20, color: "#0288d1", mt: 0.5 }} />
            <Box flex={1}>
              <Typography variant="body2">
                <b>3 ongoing bookings</b> overdue by 2+ hours. Review for SLA
                breaches.
              </Typography>
            </Box>
            <Button
              size="small"
              variant="text"
              sx={{ textTransform: "none" }}
              onClick={() => navigate("/service-bookings")}
            >
              View Overdue Bookings ›
            </Button>
          </Box>
        </Stack>
      </div>

      {/* Selection Action Bar & AI Alert */}
      {selectedBookings.length > 0 && (
        <Stack spacing={2} sx={{ mb: 2 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              p: 1.5,
              bgcolor: "#fff",
              borderRadius: "12px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
              border: "1px solid #e2e8f0",
            }}
          >
            <Stack direction="row" spacing={2}>
              <Button
                variant="contained"
                sx={{ bgcolor: "#f59e0b", "&:hover": { bgcolor: "#d97706" }, textTransform: "none", fontWeight: 600 }}
                startIcon={<WarningAmberIcon />}
              >
                Escalate SLA Risk
              </Button>
              <Button
                variant="outlined"
                sx={{ color: "#10b981", borderColor: "#10b981", "&:hover": { borderColor: "#059669", bgcolor: "#f0fdfa" }, textTransform: "none", fontWeight: 600 }}
                startIcon={<NotificationsActiveOutlinedIcon />}
              >
                Notify Delayed Customers
              </Button>
              <Button
                variant="outlined"
                sx={{ color: "#64748b", borderColor: "#e2e8f0", textTransform: "none", fontWeight: 600 }}
                startIcon={<FileDownloadOutlinedIcon />}
              >
                Bulk Export CSV
              </Button>
            </Stack>
            <Button
              variant="text"
              sx={{ color: "#64748b", textTransform: "none" }}
              onClick={() => setSelectedBookings([])}
            >
              Cancel
            </Button>
          </Box>
        </Stack>
      )}

      <div className="table_flex mt_20">
        <div className="lt">
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search orders..."
                />
              </Box>
              <div className="form">
                <div className="control_group">
                  <input type="date" />
                </div>
                <select>
                  <option value="all">Status</option>
                  <option value="pending">Pending</option>
                  <option value="accepted">Accepted</option>
                  <option value="ongoing">Ongoing</option>
                </select>
            
              </div>
            </div>
          </div>

          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      indeterminate={
                        selectedBookings.length > 0 &&
                        selectedBookings.length < orderData.length
                      }
                      checked={
                        orderData.length > 0 &&
                        selectedBookings.length === orderData.length
                      }
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                  <TableCell>Booking ID</TableCell>
                  <TableCell>Service Provider Details</TableCell>
                  <TableCell>Service Details</TableCell>
                  <TableCell>Duration</TableCell>
                  <TableCell>Vendor Details</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orderData.map((order, index) => {
                  const isItemSelected = selectedBookings.indexOf(order.bookingId) !== -1;
                  return (
                    <TableRow
                      key={index}
                      hover
                      selected={isItemSelected}
                      onClick={() => handleSelectOne(order.bookingId)}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={isItemSelected}
                          onChange={() => handleSelectOne(order.bookingId)}
                        />
                      </TableCell>
                      <TableCell>
                        <b>{order.bookingId}</b>
                        <Typography variant="caption" display="block" color="textSecondary" sx={{ fontSize: '9px' }}>
                          BK-2025-010-100%
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box className="user_block">
                          <p>
                            <b>{order.serviceProvider.name}</b>
                            <span style={{ fontSize: '11px' }}>{order.serviceProvider.email}</span>
                          </p>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Chip label="AC Repair" size="small" sx={{ height: 20, fontSize: 10, bgcolor: '#f1f5f9', fontWeight: 600 }} />
                        <Box display="flex" alignItems="center" gap={0.5} mt={0.5}>
                          <Typography variant="caption" sx={{ fontSize: 10, color: '#64748b' }}>60 min |</Typography>
                          <Typography variant="caption" sx={{ fontSize: 10, color: '#10b981', fontWeight: 700 }}>↑ 41 [4]</Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>60 min</Typography>
                      </TableCell>
                      <TableCell>
                        <Box className="user_block">
                          <p>
                            <b>{order.vendor.name}</b>
                            <span style={{ fontSize: '11px' }}>{order.bookingDate} {order.bookingTime}</span>
                          </p>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <b>{order.amount}</b>
                      </TableCell>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("/manage-vendors/view-vendor/view-service");
                          }}
                        >
                          <img src="/static/images/eye_icon.svg" alt="View" style={{ width: 18 }} />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleActionClick(e, order);
                          }}
                        >
                          <MoreVertIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div className="rt">
          <div className="ai_panel">
            <h4>AI Insights</h4>

            <div className="ai_alert warning">
              <span className="icon">⚠️</span>
              <p>
                <b>7 SKUs</b> need immediate attention
              </p>
            </div>

            <div className="ai_alert danger">
              <span className="icon">⛔</span>
              <p>
                <b>3 SKUs</b> have zero sales in 30 days
              </p>
            </div>

            <small className="ai_update">
              Next updated ETA: <b>May 5, 2024</b>
            </small>

            <div className="ai_sku_list">
              <div className="ai_sku_row">
                <div className="ai_sku_info">
                  <h5>#PRD_002</h5>
                  <p>Likely to go out of stock by May</p>
                </div>
                <button className="ai_action_btn">Actions ▾</button>
              </div>

              <div className="ai_sku_row">
                <div className="ai_sku_info">
                  <h5>#PRD_010</h5>
                  <p>Likely to go out of stock by May</p>
                </div>
                <button className="ai_action_btn">Actions ▾</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseActions}>
        <MenuItem onClick={handleCloseActions}>Change Status</MenuItem>
        <MenuItem onClick={handleCloseActions}>Ban Service Provider</MenuItem>
        <MenuItem onClick={handleCloseActions}>Initiate Payout</MenuItem>
        <MenuItem onClick={handleCloseActions}>Contact Vendor</MenuItem>
      </Menu>
    </>
  );
};

export default ServiceBookings;
